import React from "react";
import PropTypes from "prop-types";
import { Col } from "reactstrap";

import Tile, {
  TileTitle,
  TileHeader,
  TileBody
} from "shared/react_components/Tile";
import DataList, { Datum } from "shared/react_components/DataList";
import Timestamp from "shared/react_components/Timestamp";
import FormattedDate from "shared/react_components/FormattedDate";

import OptionalDatumCol from "./OptionalDatumCol";
import PhrasesSpoken from "./PhrasesSpoken";

const AboutThisCall = ({
  cuid,
  startTime,
  duration,
  ivrDuration,
  connectedDuration,
  source,
  destination,
  transactions,
  segmentPath,
  realTimeRoutingResponse,
  endReason,
  description,
  keypresses,
  phrasesSpoken
}) => {
  return (
    <Tile style={{ height: 400 }}>
      <TileHeader>
        <TileTitle>About This Call</TileTitle>
      </TileHeader>
      <TileBody>
        <DataList className="row">
          <Col md={6} lg={12} xl={6} className="mb-3">
            <Datum label="Call Record ID">{cuid}</Datum>
          </Col>

          <Col md={6} lg={12} xl={6} className="mb-3">
            <Datum label="Call Start Time">
              <FormattedDate date={startTime} />
            </Datum>
          </Col>

          <Col md={6} lg={12} xl={6} className="mb-3">
            <Datum label="Total IVR Duration">
              <Timestamp seconds={ivrDuration} />
            </Datum>
          </Col>

          <Col md={6} lg={12} xl={6} className="mb-3">
            <Datum label="Total Connected Duration">
              <Timestamp seconds={connectedDuration} />
            </Datum>
          </Col>

          <Col md={6} lg={12} xl={6} className="mb-3">
            <Datum label="Total Duration">
              <Timestamp seconds={duration} />
            </Datum>
          </Col>

          <OptionalDatumCol label="Total Keypresses">
            {keypresses}
          </OptionalDatumCol>

          <OptionalDatumCol label="Destination Phone Number">
            {destination}
          </OptionalDatumCol>

          <OptionalDatumCol label="End Of Call Reason">
            {endReason}
          </OptionalDatumCol>

          <OptionalDatumCol label="Real Time Routing Response">
            {realTimeRoutingResponse}
          </OptionalDatumCol>

          <OptionalDatumCol label="Call Segment Path">
            {segmentPath}
          </OptionalDatumCol>

          <Col md={6} lg={12} xl={6} className="mb-3">
            <Datum label="Transactions">{transactions}</Datum>
          </Col>

          <Col md={6} lg={12} xl={6} className="mb-3">
            <Datum label="Source">{source}</Datum>
          </Col>

          <OptionalDatumCol label="Promo Number Description">
            {description}
          </OptionalDatumCol>

          {phrasesSpoken && (
            <Col md={6} lg={12} xl={6} className="mb-3">
              <Datum label="Spoken Phrases">
                <PhrasesSpoken phrasesSpoken={phrasesSpoken} />
              </Datum>
            </Col>
          )}
        </DataList>
      </TileBody>
    </Tile>
  );
};

AboutThisCall.propTypes = {
  cuid: PropTypes.string.isRequired,
  startTime: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  ivrDuration: PropTypes.number.isRequired,
  connectedDuration: PropTypes.number.isRequired,
  source: PropTypes.string.isRequired,
  destination: PropTypes.string,
  transactions: PropTypes.number.isRequired,
  segmentPath: PropTypes.string,
  realTimeRoutingResponse: PropTypes.string,
  endReason: PropTypes.string,
  phrasesSpoken: PropTypes.array,
  description: PropTypes.string,
  keypresses: PropTypes.string
};

export default AboutThisCall;
